module.exports = __webpack_public_path__ + "@/assets/img/flywire_logo.eed1db6f.png";